import React, { ReactNode, RefObject, useEffect, useRef, useState, FC } from 'react'

import { IChildrenBaseProps } from '../types'

import './Dropdown.scss'

interface IProps extends IChildrenBaseProps {
  mainClass?: string
  iconClass?: string
  note?: string
  label: string
  rf?: string
  children: ReactNode
}

const DROPDOWN_CONT_CLASS =
  'csas-claim csas-center csas-selectbox csas-selectbox-red-bg csas-click-with-icon csas-click csas-click--red csas-mb-xs dropdown'

/**
 * Follow up CTA button link in form of select box with list of links
 * @param {string} mainClass CSS class of grid
 * @param {string} iconClass CSS class of icon of the button
 * @param {string} label Label of select button
 * @param {string} note Note text under the button
 * @param {string} rf rf attribute
 */
const Dropdown: FC<IProps> = ({ mainClass, iconClass, note, label, children, rf }) => {
  const followUpRef: RefObject<HTMLDivElement> = useRef()

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick)
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])

  const [open, setOpen] = useState(false)

  const handleClick = () => setOpen(!open)
  const handleOutsideClick = (e: any) => {
    if (!followUpRef.current.contains(e.target)) {
      setOpen(false)
    }
  }

  return (
    <div className={mainClass || 'csas-center cs-follow-up-dropdown'} ref={followUpRef} onClick={handleClick}>
      <div className={[DROPDOWN_CONT_CLASS, open ? 'open' : ''].join(' ')} data-testid={rf}>
        <div className='csas-selected'>
          {iconClass && <i data-testid='fu-dropdown-icon' className={iconClass}></i>}
          {label}
          <span className='caret'></span>
        </div>
        <div className='csas-option-wrapper'>
          <ol className='csas-option-wrapper-inner' data-testid='fu-dropdown-children'>
            {children}
          </ol>
        </div>
      </div>
      {note && <div className='csac-claim-text csas-claim csas-center'>{note}</div>}
    </div>
  )
}

export { Dropdown, IProps }
